import React, { useEffect, useState } from "react";
import { connect } from "react-redux";
import { Link } from "react-router-dom";
import Switch from "react-switch";
import { Label } from "reactstrap";
import { IApplicationState } from "../../../redux/reducers";
import searchService from "../../../services/searchService";
import { routes } from "../../../routes/routes";
import { DefaultNumberFormat } from "../../../utils/numbers";
import { availableSubscriptionPlans } from "../../../utils/constants";

interface IProps {
	show: boolean;
	showingResults?: boolean;
	searchFilter: any;
	isSupplier?: any;
	permissions?: any;
	credits?: any;
	setSearchFilter: (filter: any) => Promise<any>;
	subscription_type?: string;
	totalResults?: number;
}

const SearchFilter: React.FC<IProps> = ({ show, setSearchFilter, searchFilter, ...props }) => {
	useEffect(() => {
		const cleanup = () => {
			setSearchFilter(undefined);
		};
		return cleanup();
	}, []);

	const isSupplier = props.subscription_type === availableSubscriptionPlans.supplier;
	const isFreeTier = !props.subscription_type ||
		!Object.values(availableSubscriptionPlans).includes(props.subscription_type as availableSubscriptionPlans);
	const hasRemainingCredits = (props.credits?.credits?.ingredient_searches?.remaining ?? 1) > 0 && !isSupplier;

	const handleToggle = (name: string) => {
		if (!hasRemainingCredits || isSupplier) return;
		const filter = searchFilter?.name == name ? undefined : { name: name, status: true };
		setSearchFilter(filter);
	};

	const filters = [
		{ label: "Product Application", value: "food_group" },
		{ label: "Ingredient Type", value: "category" },
		{ label: "Products Using", value: "products_using" },
		{ label: "Packaging", value: "packaging" }
	];

	return (
		<div
			className={`search-filter-container ${show ? "show" : ""} row mr-0 ml-0 ${props.showingResults ? "" : "no-results"
				}`}
		>
			<div className="col-12">
				<div className={"search-filter-header"}>
					<h5>Search By: </h5>
					<Link
						to={props.permissions?.features?.has_analytics_access !== false ? "/app/search" : "#"}
						onClick={(e) => {
							if (props.permissions?.features?.has_analytics_access === false) {
								e.preventDefault();
							}
						}}
						style={{ cursor: props.permissions?.features?.has_analytics_access === false || isSupplier ? "not-allowed" : "pointer" }}
					>
						<div className={`advanced-search ${props.permissions?.features?.has_analytics_access === false || isSupplier ? "disabled" : ""}`}>
							Advanced Search
						</div>
					</Link>
				</div>

				<div className="search-filters">
					{filters.map((filter: { label: string; value: string }, index: number) => {
						const isDisabled = !hasRemainingCredits || isSupplier;
						return (
							<Label key={index} style={{ opacity: isDisabled ? 0.6 : 1, cursor: isDisabled ? "not-allowed" : "pointer" }}>
								<span className="mr-2">{filter.label}</span>
								<Switch
									disabled={isDisabled}
									onChange={() => handleToggle(filter.value)}
									checked={searchFilter?.name == filter.value}
									onColor="#3F65F1"
									onHandleColor="#2693e6"
									handleDiameter={21}
									uncheckedIcon={false}
									checkedIcon={false}
									boxShadow="0px 1px 5px rgba(0, 0, 0, 0.6)"
									activeBoxShadow="0px 0px 1px 10px rgba(0, 0, 0, 0.2)"
									height={20}
									width={40}
								/>
							</Label>
						);
					})}
				</div>

				<div className="search-filter-count d-flex align-items-center">
					<span style={{ fontSize: 18, color: "#212529" }}>
						Search Result: <b>{isFreeTier ? Math.min(props.totalResults || 0, 10) : DefaultNumberFormat(props.totalResults || 0)}</b>
					</span>
					{isFreeTier && (props.totalResults || 0) > 10 && (
						<div className="ml-3">
							<small style={{ color: "#e85a73", fontWeight: 600 }}>
								To see more result upgrade plan
							</small>
						</div>
					)}
				</div>

				{(!hasRemainingCredits || isSupplier) && (
					<div className="mt-2 text-right">
						<small style={{ color: "#e85a73", fontWeight: 600 }}>
							{isSupplier ? "Search filters are not available on your plan." : "Search limits exceeded. Please upgrade your plan."}
						</small>
					</div>
				)}
			</div>
		</div>
	);
};

const mapStateToProps = (state: IApplicationState) => ({
	searchFilter: state.search.filter,
	permissions: state.user.permissions,
	credits: state.user.credits,
	totalResults: state.search.paginated_results?.pagination?.total,
	subscription_type: state.user?.profile?.company?.subscription_type
});

const mapDispatchToProps = {
	setSearchFilter: (filter: any) => searchService.setSearchFilter(filter)
};
export default connect(mapStateToProps, mapDispatchToProps)(SearchFilter);
